/**

 * Variantes disponibles:
 * - 'coke-red'      → Rojo Coca-Cola (diseño actual)
 * - 'almacen-dark'  → Modo oscuro elegante
 * - 'ocean-blue'    → Azul corporativo
 * - 'soft-purple'   → Púrpura moderno
 * - 'forest-green'  → Verde natural
 */

export const HEADER_VARIANTS = {
  '1': {
    name: 'Coca-Cola Red',
    primary: '#ff0102',
    accent: '#ff0102',
    primaryLight: '#fff0f0',
    primaryTransparent: 'rgba(255, 1, 2, 0.08)',
    text: '#ffffff',
    textDark: '#111111',
    avatarBorder: '#eeeeee',
    inactive: '#666666',
    divider: '#dddddd',
    menuBg: '#ffffff',
    menuText: '#333333',
    menuHover: '#f5f5f5',
  },
  '2': {
    name: 'Almacen Dark',
    primary: '#1a1a2e',
    accent: '#1a1a2e',
    primaryLight: '#2a2a3e',
    primaryTransparent: 'rgba(26, 26, 46, 0.08)',
    text: '#ffffff',
    textDark: '#ffffff',
    avatarBorder: '#333344',
    inactive: '#888888',
    divider: '#444455',
    menuBg: '#252538',
    menuText: '#e0e0e0',
    menuHover: '#33334d',
  },
  '3': {
    name: 'Ocean Blue',
    primary: '#0066cc',
    accent: '#0066cc',
    primaryLight: '#e6f2ff',
    primaryTransparent: 'rgba(0, 102, 204, 0.08)',
    text: '#ffffff',
    textDark: '#003366',
    avatarBorder: '#cce5ff',
    inactive: '#666666',
    divider: '#dddddd',
    menuBg: '#ffffff',
    menuText: '#333333',
    menuHover: '#f5f5f5',
  },
  '4': {
    name: 'Soft Purple',
    primary: '#6b4c9a',
    accent: '#6b4c9a',
    primaryLight: '#f0e6ff',
    primaryTransparent: 'rgba(107, 76, 154, 0.08)',
    text: '#ffffff',
    textDark: '#4a3570',
    avatarBorder: '#e8dff5',
    inactive: '#666666',
    divider: '#dddddd',
    menuBg: '#ffffff',
    menuText: '#333333',
    menuHover: '#f5f5f5',
  },
  '5': {
    name: 'Forest Green',
    primary: '#2d6a4f',
    accent: '#2d6a4f',
    primaryLight: '#e8f5e9',
    primaryTransparent: 'rgba(45, 106, 79, 0.08)',
    text: '#ffffff',
    textDark: '#1b4332',
    avatarBorder: '#c8e6c9',
    inactive: '#666666',
    divider: '#dddddd',
    menuBg: '#ffffff',
    menuText: '#333333',
    menuHover: '#f5f5f5',
  },
  '6': {
    name: 'Sunset Gradient',
    primary: 'linear-gradient(135deg, #FF334B 0%, #E61980 50%, #A326F5 100%)',
    accent: '#E61980',
    primaryLight: 'rgba(230, 25, 128, 0.12)',
    primaryTransparent: 'rgba(163, 38, 245, 0.08)',
    text: '#ffffff',
    textDark: '#4a0e5c',
    avatarBorder: '#f5d0e8',
    inactive: '#666666',
    divider: '#dddddd',
    menuBg: '#ffffff',
    menuText: '#333333',
    menuHover: '#f5f5f5',
  },
  '7': {
  name: 'Cyber Blue',
  primary: 'linear-gradient(135deg, #00C6FF 0%, #0072FF 100%)',
  accent: '#0072FF',
  primaryLight: 'rgba(0, 114, 255, 0.12)',
  primaryTransparent: 'rgba(0, 114, 255, 0.08)',
  text: '#ffffff',
  textDark: '#003b80',
  avatarBorder: '#cce7ff',
  inactive: '#666666',
  divider: '#dddddd',
  menuBg: '#ffffff',
  menuText: '#333333',
  menuHover: '#f5f5f5',
},

'8': {
  name: 'Emerald Dream',
  primary: 'linear-gradient(135deg, #11998E 0%, #38EF7D 100%)',
  accent: '#11998E',
  primaryLight: 'rgba(17, 153, 142, 0.12)',
  primaryTransparent: 'rgba(17, 153, 142, 0.08)',
  text: '#ffffff',
  textDark: '#0b5c55',
  avatarBorder: '#c7f5e8',
  inactive: '#666666',
  divider: '#dddddd',
  menuBg: '#ffffff',
  menuText: '#333333',
  menuHover: '#f5f5f5',
},

'9': {
  name: 'Royal Purple',
  primary: 'linear-gradient(135deg, #667EEA 0%, #764BA2 100%)',
  accent: '#764BA2',
  primaryLight: 'rgba(118, 75, 162, 0.12)',
  primaryTransparent: 'rgba(118, 75, 162, 0.08)',
  text: '#ffffff',
  textDark: '#4b2e68',
  avatarBorder: '#e2d7f5',
  inactive: '#666666',
  divider: '#dddddd',
  menuBg: '#ffffff',
  menuText: '#333333',
  menuHover: '#f5f5f5',
},

'10': {
  name: 'Orange Fire',
  primary: 'linear-gradient(135deg, #F7971E 0%, #FF512F 100%)',
  accent: '#FF512F',
  primaryLight: 'rgba(255, 81, 47, 0.12)',
  primaryTransparent: 'rgba(255, 81, 47, 0.08)',
  text: '#ffffff',
  textDark: '#8a2e12',
  avatarBorder: '#ffe0d4',
  inactive: '#666666',
  divider: '#dddddd',
  menuBg: '#ffffff',
  menuText: '#333333',
  menuHover: '#f5f5f5',
},

'11': {
  name: 'Neon Pink',
  primary: 'linear-gradient(135deg, #FF0099 0%, #493240 100%)',
  accent: '#FF0099',
  primaryLight: 'rgba(255, 0, 153, 0.12)',
  primaryTransparent: 'rgba(255, 0, 153, 0.08)',
  text: '#ffffff',
  textDark: '#5e0038',
  avatarBorder: '#ffd6ef',
  inactive: '#666666',
  divider: '#dddddd',
  menuBg: '#ffffff',
  menuText: '#333333',
  menuHover: '#f5f5f5',
},

'12': {
  name: 'Aurora',
  primary: 'linear-gradient(135deg, #00F5A0 0%, #00D9F5 50%, #007CF0 100%)',
  accent: '#00D9F5',
  primaryLight: 'rgba(0, 217, 245, 0.12)',
  primaryTransparent: 'rgba(0, 217, 245, 0.08)',
  text: '#ffffff',
  textDark: '#004b66',
  avatarBorder: '#d2f9ff',
  inactive: '#666666',
  divider: '#dddddd',
  menuBg: '#ffffff',
  menuText: '#333333',
  menuHover: '#f5f5f5',
},

'13': {
  name: 'Midnight',
  primary: 'linear-gradient(135deg, #141E30 0%, #243B55 100%)',
  accent: '#243B55',
  primaryLight: 'rgba(36, 59, 85, 0.12)',
  primaryTransparent: 'rgba(36, 59, 85, 0.08)',
  text: '#ffffff',
  textDark: '#243B55',
  avatarBorder: '#d6dde6',
  inactive: '#888888',
  divider: '#dddddd',
  menuBg: '#ffffff',
  menuText: '#333333',
  menuHover: '#f5f5f5',
},

'14': {
  name: 'Galaxy',
  primary: 'linear-gradient(135deg, #654EA3 0%, #EAAFc8 100%)',
  accent: '#654EA3',
  primaryLight: 'rgba(101, 78, 163, 0.12)',
  primaryTransparent: 'rgba(101, 78, 163, 0.08)',
  text: '#ffffff',
  textDark: '#432c7a',
  avatarBorder: '#f0dff0',
  inactive: '#666666',
  divider: '#dddddd',
  menuBg: '#ffffff',
  menuText: '#333333',
  menuHover: '#f5f5f5',
},
};
//cambio de color del header
export const ACTIVE_HEADER_VARIANT = '6';

export const getHeaderTheme = () => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT];
